import currency from 'currency.js';

export default function (value) {
  return currency(value, { symbol: "€", separator: ".", decimal: ",", pattern: '# !', negativePattern: '-# !' });
}
